// extracted by mini-css-extract-plugin
export default {"root":"UsageAnalyticsPage_root__p9Ko3","body":"UsageAnalyticsPage_body__EU2Eh","row":"UsageAnalyticsPage_row__qh1I1"};